<script setup lang="ts">
import type { UserDetailV2 } from "~/modules/user/models/UserDetailV2.interface";

const { t, locale } = useI18n();
const props = defineProps<{
  user?: UserDetailV2;
}>();

const emit = defineEmits(["saveLanguage"]);

const language = ref(props.user?.language);

const onClick = () => {
  emit("saveLanguage", {
    language,
  });
};
</script>

<template>
  <container-component :px="0" :py="0">
    <h2>{{ t("user.userAccount.language.title") }}</h2>

    <span>
      {{ t("user.userAccount.instructions.language") }}
    </span>

    <lxc-form ref="userLanguageForm">
      <lxc-form-item class="max-w-64 pt-2">
        <language-component v-model="language" />
      </lxc-form-item>
      <lxc-form-item>
        <lxc-button
          type="primary"
          html-type="button"
          :title="t('user.userAccount.forms.validate')"
          :disabled="!language || language === locale"
          @click="onClick"
        >
          {{ t("user.userAccount.forms.validate") }}
        </lxc-button>
      </lxc-form-item>
    </lxc-form>
  </container-component>
</template>
